import { useContext, useState } from "react";
import { AuthContext } from "../context/auth-context";

import PoshLogo from "./UI/PoshLogo";
import poshBkg from "../assets/img/posh-bg.webp";

export default function LoginPage() {
  const { login, error, resetPassword } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);

  const formHandler = (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const password = event.target.password.value;
    login(email, password);
    
  };

  const forgotPasswordHandler = () => {
    const email = document.getElementById("email").value;
    resetPassword(email);
  };

  return (
    <div className="grid h-screen bg-gradient-to-br from-stone-900">
      <img
        className="fixed top-0 left-0 object-cover w-screen h-screen -z-10"
        src={poshBkg}
      />
      <div className="flex items-end self-start p-6 space-x-4">
        <PoshLogo />
        <p className="text-2xl md:text-3xl font-extralight text-stone-400">
          Partner
        </p>
      </div>

      <div className="grid justify-center gap-8 p-8 m-auto rounded-lg shadow-lg bg-stone-900 w-96 h-fit">
        <form onSubmit={formHandler} className="grid gap-4">
          <div>
            <label className="text-stone-400">Email: </label>
            <input
              className="w-full form-input"
              name="email"
              type="email"
              id="email"
              required
            />
          </div>
          <div>
            <label className="text-stone-400">Password: </label>
            <input
              className="w-full form-input"
              name="password"
              type={showPassword ? "text" : "password"}
              required
            />

            <p
              onClick={() => setShowPassword(!showPassword)}
              className="mt-1 text-xs text-right cursor-pointer text-stone-400 hover:underline"
            >
              {showPassword ? (
                <span>Hide Password</span>
              ) : (
                <span>Show Password</span>
              )}
            </p>
          </div>
          <div className="grid gap-4 h-fit">
            <button type="submit" className="w-full mt-1 btn-primary">
              Sign In
            </button>
            <div onClick={forgotPasswordHandler} className="btn-secondary">Forgot Password</div>
            {error && (
              <p className="text-sm text-center text-red-600">{error}</p>
            )}
          </div>
        </form>
      </div>

      <div className="grid self-end p-4 text-center shadow-lg lg:grid-cols-2"></div>
    </div>
  );
}
